/* ============================================================
   Nordstealth — Retoureportal.

   Gehoert zu sections/ns-retoure.liquid und laedt nur mit ihr.

   Hausstil wie assets/ns-sendung.js: ES5, kein const/let, keine
   Pfeilfunktionen, keine Template-Literale, kein async/await, kein
   AbortController. Das ist keine Nostalgie, sondern die Regel des
   Themes: eine einzige Syntaxfalle in einer Datei ohne Buendelung
   nimmt die ganze Seite mit, und niemand sieht es.

   Fuenf Entscheidungen, die man ohne diesen Kasten nicht erraet:

   1. KEIN localStorage. Weder Entwurf noch Vorgangsnummer. Auf einem
      geteilten Geraet stuenden dort Name, Anschrift und Adresse des
      Vorbesitzers. Der Entwurf lebt im Speicher dieser Seite, und
      wer wegnavigiert, wird vorher gefragt (beforeunload).
   2. Der Ausweis wird EINMAL geholt und als signierter Zettel
      ("nachweis") mitgeschickt. Die Seite selbst behauptet nie, dass
      geprueft wurde; das entscheidet der Worker anhand der Signatur.
   3. Die Artikelzeilen entstehen aus zwei <template>-Vorlagen im
      Markup, nicht aus zusammengebautem HTML. Damit steht jede
      Beschriftung in der Sektion und ist im Theme-Editor aenderbar.
   4. Bilder werden im Browser verkleinert und erst beim Absenden
      mitgeschickt, alles in EINER Anfrage. Zwei Anfragen koennten
      halb gelingen, und dann laege ein Bild ohne Vorgang herum.
   5. Beim Absenden wird der Knopf gesperrt, aber KEIN Feld. Schlaegt
      der Versand fehl, muss der zweite Anlauf ein vollstaendig
      bedienbares Formular vorfinden.
   ============================================================ */
(function () {
  // Sprachschicht: auf einer deutschen Seite gibt es window.NSI18N nicht,
  // dann bleibt der zweite Parameter stehen. snippets/ns-i18n.liquid fuellt
  // NSI18N nur fuer andere Sprachen — der deutsche Weg aendert sich nicht.
  function T(s, d) { var w = window.NSI18N; return (w && typeof w[s] === 'string') ? w[s] : d; }
  'use strict';

  var WURZEL = document.querySelector('[data-ns-retoure]');
  if (!WURZEL) return;

  function q(sel, ctx) {
    return (ctx || WURZEL).querySelector(sel);
  }
  function qa(sel, ctx) {
    return Array.prototype.slice.call((ctx || WURZEL).querySelectorAll(sel));
  }
  function txt(wert) {
    return (wert == null ? '' : String(wert)).trim();
  }
  function zahl(wert, ersatz) {
    var n = parseInt(wert, 10);
    return isNaN(n) ? ersatz : n;
  }

  var FORM = q('[data-rt-form]');
  var FERTIG = q('[data-rt-fertig]');
  var MELDER = q('[data-rt-melder]');
  if (!FORM) return;

  var ENDPUNKT = txt(WURZEL.getAttribute('data-endpunkt')).replace(/\/+$/, '');
  var PRUEF_ADRESSE = ENDPUNKT ? ENDPUNKT + '/pruefen' : '';
  var FRIST_RUECKNAHME = zahl(WURZEL.getAttribute('data-frist-ruecknahme'), 30);
  var MAX_FOTOS = zahl(WURZEL.getAttribute('data-max-fotos'), 4);
  var MAX_MB = zahl(WURZEL.getAttribute('data-max-mb'), 3);
  var HILFSMAIL = txt(WURZEL.getAttribute('data-mail'));
  var PRODUKT = txt(WURZEL.getAttribute('data-produkt')) || T('ns.js.rt.produkt_fallback', 'Artikel');
  var ERLAUBTE_TYPEN = ['image/png', 'image/jpeg'];
  var START = new Date().getTime();
  var SANFT = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var stand = {
    schritt: 0,
    geprueft: false,
    gast: false,
    nachweis: '',
    nr: '',
    mail: '',
    bestellung: null,
    fotos: [],
    laeuft: false,
    gesendet: false,
    beruehrt: false
  };

  /* ============================================================
     A. Meldungen und Fehler
     ============================================================ */

  function melde(text) {
    if (MELDER) MELDER.textContent = text;
  }

  function fehler(schluessel, text) {
    var el = q('[data-rt-fehler="' + schluessel + '"]');
    if (!el) return;
    if (text) {
      el.textContent = text;
      el.hidden = false;
      melde(text);
    } else {
      el.textContent = '';
      el.hidden = true;
    }
  }

  function fehlerWeg(bereich) {
    qa('[data-rt-fehler]', bereich || WURZEL).forEach(function (el) {
      el.hidden = true;
      el.textContent = '';
    });
    qa('.is-falsch', bereich || WURZEL).forEach(function (el) {
      el.classList.remove('is-falsch');
    });
  }

  // Die Antwort des Workers traegt einen Grund fuer die Maschine und
  // manchmal einen Satz fuer den Menschen. Fehlt der Satz, steht hier
  // einer bereit: eine Fehlermeldung ohne Ausweg ist keine.
  var GRUNDTEXT = {
    eingabe: T('ns.js.rt.durchsehen', 'Bitte sieh die Angaben noch einmal durch.'),
    nicht_gefunden: T('ns.js.rt.nicht_gefunden', 'Zu dieser Nummer und dieser E-Mail finden wir keine Bestellung. Prüf bitte beides.'),
    zu_viele: T('ns.js.rt.zu_viele', 'Zu viele Versuche. Bitte probier es in einer Minute noch einmal.'),
    zu_schnell: T('ns.js.rt.durchsehen', 'Bitte sieh die Angaben noch einmal durch.'),
    signatur: T('ns.js.rt.signatur', 'Der Zugang ist gerade nicht möglich.'),
    stoerung: T('ns.js.rt.allgemein', 'Das hat gerade nicht geklappt. Bitte versuch es gleich noch einmal.')
  };

  function antworttext(daten, http) {
    if (daten && daten.fehler) return daten.fehler;
    if (daten && daten.grund && GRUNDTEXT[daten.grund]) return GRUNDTEXT[daten.grund];
    if (http === 0) return T('ns.js.rt.keine_verbindung', 'Keine Verbindung. Prüf bitte dein Netz und versuch es noch einmal.');
    return GRUNDTEXT.stoerung;
  }

  function mitAusweg(text) {
    if (!HILFSMAIL) return text;
    return text + T('ns.js.rt.dabei_bleibt', ' Wenn es dabei bleibt, schreib uns an ') + HILFSMAIL + '.';
  }

  /* ============================================================
     B. Schritte
     ============================================================ */

  var SCHRITTE = qa('[data-rt-schritt]').sort(function (a, b) {
    return zahl(a.getAttribute('data-rt-schritt'), 0) - zahl(b.getAttribute('data-rt-schritt'), 0);
  });
  var STUFEN = qa('[data-rt-stufe]');

  function zeigeSchritt(index, fokus) {
    stand.schritt = Math.max(0, Math.min(SCHRITTE.length - 1, index));
    SCHRITTE.forEach(function (el, i) {
      el.hidden = i !== stand.schritt;
    });
    STUFEN.forEach(function (el, i) {
      el.classList.toggle('is-jetzt', i === stand.schritt);
      el.classList.toggle('is-fertig', i < stand.schritt);
    });
    if (stand.schritt === SCHRITTE.length - 1) zusammenfassen();
    if (fokus !== false) {
      var ziel = SCHRITTE[stand.schritt];
      ziel.focus();
      rollenZu(FORM);
    }
    melde('Schritt ' + (stand.schritt + 1) + ' von ' + SCHRITTE.length);
  }

  function rollenZu(el) {
    if (!el) return;
    var oben = el.getBoundingClientRect().top + window.pageYOffset - 24;
    try {
      window.scrollTo({ top: oben, behavior: SANFT ? 'smooth' : 'auto' });
    } catch (e) {
      window.scrollTo(0, oben);
    }
  }

  qa('[data-rt-weiter]').forEach(function (knopf) {
    knopf.addEventListener('click', function () {
      if (!schrittGeprueft(stand.schritt)) return;
      zeigeSchritt(stand.schritt + 1);
    });
  });

  qa('[data-rt-zurueck]').forEach(function (knopf) {
    knopf.addEventListener('click', function () {
      zeigeSchritt(stand.schritt - 1);
    });
  });

  /* ============================================================
     C. Schritt 1: Bestellung suchen
     ============================================================ */

  var feldNr = q('[name="nr"]');
  var feldMail = q('[name="mail"]');
  var knopfPruefen = q('[data-rt-pruefen]');
  var kastenTreffer = q('[data-rt-treffer]');
  var navEins = q('[data-rt-nav-eins]');
  var gastKnopf = q('[data-rt-gast]');
  var gastBlock = q('[data-rt-gast-block]');

  // Der Notausgang erscheint erst, wenn wirklich einmal gesucht wurde.
  // Eine falsch getippte Nummer zaehlt nicht: dabei geht keine Anfrage
  // raus, und der Kunde soll sie erst korrigieren.
  function auswegZeigen() {
    if (!gastBlock || !gastBlock.hidden) return;
    gastBlock.hidden = false;
    melde(T('ns.js.rt.ohne_nummer_moeglich', 'Du kannst auch ohne Bestellnummer fortfahren.'));
  }

  function auswegVerbergen() {
    if (gastBlock) gastBlock.hidden = true;
  }

  function mailGueltig(wert) {
    return /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(txt(wert));
  }

  function pruefen() {
    if (stand.laeuft) return;
    fehler('suche', '');
    var nr = txt(feldNr && feldNr.value).replace(/\s+/g, '');
    var mail = txt(feldMail && feldMail.value).toLowerCase();

    if (!/^#?\d{3,12}$/.test(nr)) {
      if (feldNr) feldNr.classList.add('is-falsch');
      fehler('suche', T('ns.js.rt.nur_ziffern', 'Die Bestellnummer besteht nur aus Ziffern, zum Beispiel 261445.'));
      return;
    }
    if (!mailGueltig(mail)) {
      if (feldMail) feldMail.classList.add('is-falsch');
      fehler('suche', T('ns.js.rt.mail_eintragen', 'Bitte trag die E-Mail-Adresse ein, an die die Bestellbestätigung ging.'));
      return;
    }
    // Ohne Endpunkt gaebe es nichts zu suchen. Dann steht der Weg ohne
    // Bestellnummer sofort offen, sonst kaeme niemand weiter.
    if (!PRUEF_ADRESSE) {
      auswegZeigen();
      fehler('suche', T('ns.js.rt.suche_aus', 'Die Suche ist gerade nicht verfügbar. Du kannst die Rücksendung auch ohne Nummer anmelden.'));
      return;
    }

    laden(true);
    melde(T('ns.js.rt.wird_gesucht', 'Bestellung wird gesucht'));

    fetch(PRUEF_ADRESSE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ nr: nr, mail: mail }),
      credentials: 'omit'
    })
      .then(lesen)
      .catch(function () {
        return { http: 0, daten: null };
      })
      .then(function (a) {
        laden(false);
        if (a.daten && a.daten.ok === true) {
          stand.geprueft = true;
          stand.gast = false;
          stand.nachweis = txt(a.daten.nachweis);
          stand.nr = nr;
          stand.mail = mail;
          stand.bestellung = a.daten.bestellung;
          zeigeTreffer(a.daten.bestellung);
          zeileAusBestellung(a.daten.bestellung);
          return;
        }
        // Ab hier ist einmal wirklich gesucht worden. Erst jetzt darf der
        // Weg ohne Bestellnummer sichtbar werden, und zwar in beiden
        // Fehlerfaellen: nicht gefunden UND Stoerung. Sonst steckt fest,
        // wer nichts dafuer kann.
        var text = a.http === 404 ? GRUNDTEXT.nicht_gefunden : antworttext(a.daten, a.http);
        fehler('suche', text);
        auswegZeigen();
        // Zurueck in das Nummernfeld: der haeufigste Fall ist ein
        // Zahlendreher, und dann soll die Korrektur einen Griff kosten.
        if (a.http === 404 && feldNr) feldNr.focus();
      });
  }

  function lesen(antwort) {
    return antwort.text().then(function (roh) {
      var daten = null;
      try {
        daten = JSON.parse(roh);
      } catch (e) {
        daten = null;
      }
      return { http: antwort.status, daten: daten };
    });
  }

  function laden(an) {
    stand.laeuft = an;
    if (!knopfPruefen) return;
    knopfPruefen.disabled = an;
    var text = q('.ns-rt__btn-text', knopfPruefen);
    if (text) {
      if (an) {
        text.setAttribute('data-alt', text.textContent);
        text.textContent = 'Wird gesucht …';
      } else if (text.getAttribute('data-alt')) {
        text.textContent = text.getAttribute('data-alt');
        text.removeAttribute('data-alt');
      }
    }
  }

  function zeigeTreffer(b) {
    if (!kastenTreffer) return;
    var nrAus = q('[data-rt-treffer-nr]');
    var datumAus = q('[data-rt-treffer-datum]');
    var fristAus = q('[data-rt-frist]');
    if (nrAus) nrAus.textContent = T('ns.js.rt.bestellung_vor', 'Bestellung ') + b.nummer + ' gefunden';
    if (datumAus) {
      var anzahl = b.artikel.length;
      datumAus.textContent = b.datum_de
        ? 'Bestellt am ' + b.datum_de + ', ' + anzahl + (anzahl === 1 ? ' Artikel' : T('ns.js.rt.artikel_darin', ' Artikel darin'))
        : '';
    }
    if (fristAus) {
      fristAus.classList.remove('is-knapp');
      if (b.frist && b.frist.abgelaufen) {
        fristAus.textContent =
          'Die ' + FRIST_RUECKNAHME + T('ns.js.rt.frist_vorbei', ' Tage sind rechnerisch vorbei. Melde den Fall trotzdem an, wir sehen ihn uns an.');
        fristAus.classList.add('is-knapp');
      } else if (b.frist && b.frist.rest !== null) {
        fristAus.textContent =
          b.frist.rest === 0
            ? T('ns.js.rt.letzter_tag', 'Heute ist der letzte Tag deiner ') + FRIST_RUECKNAHME + T('ns.js.rt.tage_punkt', ' Tage.')
            : T('ns.js.rt.noch', 'Du hast noch ') + b.frist.rest + (b.frist.rest === 1 ? ' Tag' : T('ns.js.rt.tage', ' Tage')) + T('ns.js.rt.von_deinen', ' von deinen ') + FRIST_RUECKNAHME + ' Tagen.';
        if (b.frist.rest <= 3) fristAus.classList.add('is-knapp');
      } else {
        fristAus.textContent = '';
      }
    }
    kastenTreffer.hidden = false;
    if (navEins) navEins.hidden = false;
    auswegVerbergen();
    melde(T('ns.js.rt.bestellung_vor', 'Bestellung ') + b.nummer + ' gefunden');
  }

  // Der Notausgang ist zugleich die Entscheidung, ohne Nummer
  // weiterzumachen. Er fuehrt deshalb sofort in Schritt 2 statt erst
  // einen zweiten Knopf einzublenden.
  function gastWeg() {
    stand.gast = true;
    stand.geprueft = false;
    stand.nachweis = '';
    stand.bestellung = null;
    if (kastenTreffer) kastenTreffer.hidden = true;
    zeilenLeeren();
    gastZeileAnlegen();
    if (plusKnopf) plusKnopf.hidden = false;
    if (!schrittGeprueft(0)) return;
    melde(T('ns.js.rt.weiter_ohne_nummer', 'Weiter ohne Bestellnummer'));
    zeigeSchritt(1);
  }

  if (knopfPruefen) knopfPruefen.addEventListener('click', pruefen);
  if (gastKnopf) gastKnopf.addEventListener('click', gastWeg);

  // Eintasten im Suchfeld soll suchen und nicht das ganze Formular
  // abschicken. Ohne das landet man mit halben Angaben im Absenden.
  [feldNr, feldMail].forEach(function (feld) {
    if (!feld) return;
    feld.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') {
        ev.preventDefault();
        pruefen();
      }
    });
    feld.addEventListener('input', function () {
      feld.classList.remove('is-falsch');
    });
  });

  var andereKnopf = q('[data-rt-andere]');
  if (andereKnopf) {
    andereKnopf.addEventListener('click', function () {
      stand.geprueft = false;
      stand.nachweis = '';
      stand.bestellung = null;
      zeilenLeeren();
      if (kastenTreffer) kastenTreffer.hidden = true;
      if (navEins) navEins.hidden = true;
      // Auch der Notausgang geht wieder zu: es wird ja neu gesucht.
      auswegVerbergen();
      fehler('suche', '');
      if (feldNr) {
        feldNr.value = '';
        feldNr.focus();
      }
    });
  }

  /* ============================================================
     D. Schritt 2: Artikelzeilen
     ============================================================ */

  var artikelRaum = q('[data-rt-artikel]');
  var vorlageArtikel = q('[data-rt-vorlage="artikel"]');
  var vorlageGast = q('[data-rt-vorlage="gast"]');
  var plusKnopf = q('[data-rt-zeile-plus]');

  function zeilenLeeren() {
    if (artikelRaum) artikelRaum.innerHTML = '';
    if (plusKnopf) plusKnopf.hidden = true;
  }

  function zeileAusBestellung(b) {
    zeilenLeeren();
    if (!artikelRaum || !vorlageArtikel) return;
    b.artikel.forEach(function (a) {
      var knoten = vorlageArtikel.content.cloneNode(true);
      var zeile = knoten.querySelector('[data-rt-zeile]');
      var titel = knoten.querySelector('[data-rt-zeile-titel]');
      var variante = knoten.querySelector('[data-rt-zeile-variante]');
      var bild = knoten.querySelector('[data-rt-zeile-bild]');
      var mengeFeld = knoten.querySelector('[data-rt-menge-wert]');
      if (titel) titel.textContent = a.titel;
      if (variante) {
        variante.textContent = a.variante ? a.variante + ', ' + a.menge + ' bestellt' : a.menge + ' bestellt';
      }
      if (bild) {
        if (a.bild) bild.style.backgroundImage = 'url("' + a.bild.replace(/"/g, '') + '")';
        else bild.hidden = true;
      }
      if (mengeFeld) {
        mengeFeld.value = String(a.menge || 1);
        mengeFeld.setAttribute('data-rt-max', String(a.menge || 1));
      }
      if (zeile) {
        zeile.setAttribute('data-rt-titel', a.titel);
        zeile.setAttribute('data-rt-variante', a.variante || '');
      }
      artikelRaum.appendChild(knoten);
    });
    zeilenBinden();
    // Nur eine Zeile? Dann ist die Auswahl keine Auswahl. Gleich anhaken.
    var kaesten = qa('[data-rt-zeile-an]', artikelRaum);
    if (kaesten.length === 1) {
      kaesten[0].checked = true;
      zeileUmschalten(kaesten[0]);
    }
  }

  function gastZeileAnlegen() {
    if (!artikelRaum || !vorlageGast) return;
    if (qa('[data-rt-zeile]', artikelRaum).length >= 5) return;
    var knoten = vorlageGast.content.cloneNode(true);
    var zeile = knoten.querySelector('[data-rt-zeile]');
    if (zeile) zeile.setAttribute('data-rt-titel', PRODUKT);
    artikelRaum.appendChild(knoten);
    zeilenBinden();
  }

  if (plusKnopf) {
    plusKnopf.addEventListener('click', function () {
      gastZeileAnlegen();
    });
  }

  function zeileUmschalten(kasten) {
    var zeile = kasten.closest('[data-rt-zeile]');
    if (!zeile) return;
    var detail = q('[data-rt-zeile-detail]', zeile);
    zeile.classList.toggle('is-an', kasten.checked);
    if (detail && !zeile.hasAttribute('data-rt-gastzeile')) detail.hidden = !kasten.checked;
  }

  // Die Bindung laeuft ueber ein Kennzeichen am Knoten statt ueber
  // Delegation, weil Zeilen einzeln dazukommen und wieder verschwinden.
  // Zweimal gebunden hiesse zweimal gezaehlt.
  function zeilenBinden() {
    qa('[data-rt-zeile]', artikelRaum).forEach(function (zeile) {
      if (zeile.getAttribute('data-rt-gebunden') === '1') return;
      zeile.setAttribute('data-rt-gebunden', '1');

      var kasten = q('[data-rt-zeile-an]', zeile);
      if (kasten) {
        kasten.addEventListener('change', function () {
          zeileUmschalten(kasten);
          fehler('artikel', '');
        });
        zeileUmschalten(kasten);
      }

      qa('[data-rt-menge]', zeile).forEach(function (knopf) {
        knopf.addEventListener('click', function () {
          var feld = q('[data-rt-menge-wert]', zeile);
          if (!feld) return;
          var max = zahl(feld.getAttribute('data-rt-max'), 99);
          var wert = zahl(feld.value, 1) + zahl(knopf.getAttribute('data-rt-menge'), 0);
          feld.value = String(Math.max(1, Math.min(max, wert)));
        });
      });

      var mengeFeld = q('[data-rt-menge-wert]', zeile);
      if (mengeFeld) {
        mengeFeld.addEventListener('blur', function () {
          var max = zahl(mengeFeld.getAttribute('data-rt-max'), 99);
          mengeFeld.value = String(Math.max(1, Math.min(max, zahl(mengeFeld.value, 1))));
        });
      }

      var wegKnopf = q('[data-rt-zeile-weg]', zeile);
      if (wegKnopf) {
        wegKnopf.addEventListener('click', function (ev) {
          ev.preventDefault();
          if (qa('[data-rt-zeile]', artikelRaum).length <= 1) return;
          zeile.parentNode.removeChild(zeile);
        });
      }

      qa('select', zeile).forEach(function (feld) {
        feld.addEventListener('change', function () {
          feld.classList.remove('is-falsch');
          fehler('artikel', '');
        });
      });
    });
  }

  function zeilenLesen() {
    return qa('[data-rt-zeile]', artikelRaum)
      .filter(function (zeile) {
        var kasten = q('[data-rt-zeile-an]', zeile);
        return kasten && kasten.checked;
      })
      .map(function (zeile) {
        var farbe = q('[data-rt-zeile-farbe]', zeile);
        var variante = farbe ? txt(farbe.value) : txt(zeile.getAttribute('data-rt-variante'));
        return {
          titel: txt(zeile.getAttribute('data-rt-titel')),
          variante: variante,
          menge: Math.max(1, zahl((q('[data-rt-menge-wert]', zeile) || {}).value, 1)),
          grund: txt((q('[data-rt-zeile-grund]', zeile) || {}).value)
        };
      });
  }

  /* ============================================================
     E. Schritt 3: Anliegen, Zustand, Beschreibung
     ============================================================ */

  var feldZustand = q('[data-rt-zustand]');
  var feldBeschreibung = q('[data-rt-beschreibung]');
  var zaehler = q('[data-rt-zaehler]');
  var widerrufWrap = q('[data-rt-widerruf-wrap]');
  var widerrufBox = q('[data-rt-widerruf]');
  var wunschWrap = q('[data-rt-wunsch-wrap]');
  var feldWunsch = q('[data-rt-wunsch]');

  function anliegenWert() {
    var gewaehlt = q('[data-rt-anliegen]:checked');
    return gewaehlt ? txt(gewaehlt.value) : '';
  }

  function willUmtausch() {
    // Auch englisch: die Anliegen-Liste kommt aus den Einstellungen und
    // heisst dort uebersetzt "Exchange for a different colour". Ohne das
    // zweite Muster bliebe das Feld fuer die Wunschfarbe auf /en unsichtbar.
    return /umtausch|tausch|exchange|swap/i.test(anliegenWert());
  }

  qa('[data-rt-anliegen]').forEach(function (feld) {
    feld.addEventListener('change', function () {
      fehler('anliegen', '');
      // Die Widerrufserklaerung erscheint nur, wenn sie zum Anliegen
      // passt. Ein Haken, den man immer sieht, wird nicht gelesen.
      if (widerrufWrap) {
        var passt = /widerruf/i.test(anliegenWert());
        widerrufWrap.hidden = !passt;
        if (!passt && widerrufBox) widerrufBox.checked = false;
      }
      // Dasselbe fuer die Wunschfarbe: nur beim Umtausch. Sonst stuende
      // dort eine Frage, die den Vorgang nicht betrifft.
      if (wunschWrap) {
        wunschWrap.hidden = !willUmtausch();
        if (!willUmtausch() && feldWunsch) feldWunsch.value = '';
        fehler('wunsch', '');
      }
    });
  });

  if (feldZustand) {
    feldZustand.addEventListener('change', function () {
      feldZustand.classList.remove('is-falsch');
      fehler('zustand', '');
    });
  }

  if (feldWunsch) {
    feldWunsch.addEventListener('change', function () {
      feldWunsch.classList.remove('is-falsch');
      fehler('wunsch', '');
    });
  }

  if (feldBeschreibung && zaehler) {
    var grundtext = zaehler.textContent;
    feldBeschreibung.addEventListener('input', function () {
      var laenge = txt(feldBeschreibung.value).length;
      var min = zahl(feldBeschreibung.getAttribute('data-rt-min'), 10);
      if (laenge > 0 && laenge < min) {
        zaehler.textContent = 'Noch ' + (min - laenge) + ' Zeichen.';
      } else {
        zaehler.textContent = grundtext;
      }
      feldBeschreibung.classList.remove('is-falsch');
    });
  }

  /* ============================================================
     F. Fotos
     ============================================================ */

  var dateiFeld = q('[data-rt-datei]');
  var ablage = q('[data-rt-ablage]');
  var bilderListe = q('[data-rt-bilder]');

  // Unter einem Megabyte in Kilobyte. Sonst steht an einem 12-KB-Bild
  // "0,0 MB", und das liest sich wie ein Fehler.
  function mb(bytes) {
    if (bytes < 1048576) return Math.max(1, Math.round(bytes / 1024)) + ' KB';
    return (bytes / 1048576).toFixed(1).replace('.', ',') + ' MB';
  }

  // Verkleinern ueber ein Canvas. Gibt IMMER etwas zurueck: klappt es
  // nicht, geht die Originaldatei raus. Lieber gross als gar nicht.
  function verkleinern(datei, fertig) {
    var url = URL.createObjectURL(datei);
    var bild = new Image();
    var name = datei.name.replace(/\.[^.]+$/, '') + '.jpg';
    bild.onload = function () {
      try {
        var max = 2000;
        var faktor = Math.min(1, max / Math.max(bild.width, bild.height));
        var breite = Math.round(bild.width * faktor);
        var hoehe = Math.round(bild.height * faktor);
        var leinwand = document.createElement('canvas');
        leinwand.width = breite;
        leinwand.height = hoehe;
        var stift = leinwand.getContext('2d');
        // Weisser Grund: ein PNG mit Transparenz wuerde sonst schwarz.
        stift.fillStyle = '#ffffff';
        stift.fillRect(0, 0, breite, hoehe);
        stift.drawImage(bild, 0, 0, breite, hoehe);
        leinwand.toBlob(
          function (blob) {
            URL.revokeObjectURL(url);
            fertig(blob ? new File([blob], name, { type: 'image/jpeg' }) : datei);
          },
          'image/jpeg',
          0.72
        );
      } catch (e) {
        URL.revokeObjectURL(url);
        fertig(datei);
      }
    };
    bild.onerror = function () {
      URL.revokeObjectURL(url);
      fertig(datei);
    };
    bild.src = url;
  }

  function bilderZeichnen() {
    if (!bilderListe) return;
    bilderListe.innerHTML = '';
    stand.fotos.forEach(function (eintrag, i) {
      var li = document.createElement('li');
      li.className = 'ns-rt__bild';

      var vorschau = document.createElement('span');
      vorschau.className = 'ns-rt__bild-vorschau';
      if (eintrag.vorschau) vorschau.style.backgroundImage = 'url("' + eintrag.vorschau + '")';
      li.appendChild(vorschau);

      var text = document.createElement('span');
      text.className = 'ns-rt__bild-text';
      var name = document.createElement('span');
      name.className = 'ns-rt__bild-n';
      name.textContent = eintrag.name;
      var s = document.createElement('span');
      s.className = 'ns-rt__bild-s';
      if (eintrag.zustand === 'laedt') s.textContent = T('ns.js.rt.verkleinert', 'wird verkleinert …');
      else if (eintrag.zustand === 'fehler') {
        s.textContent = eintrag.meldung;
        s.className += ' is-falsch';
      } else s.textContent = mb(eintrag.groesse);
      text.appendChild(name);
      text.appendChild(s);
      li.appendChild(text);

      var weg = document.createElement('button');
      weg.type = 'button';
      weg.className = 'ns-rt__bild-weg';
      weg.setAttribute('aria-label', T('ns.js.rt.bild_entfernen', 'Bild entfernen: ') + eintrag.name);
      weg.innerHTML = '<svg aria-hidden="true"><use href="#rt-kreuz"></use></svg>';
      weg.addEventListener('click', function () {
        if (eintrag.vorschau) URL.revokeObjectURL(eintrag.vorschau);
        stand.fotos.splice(i, 1);
        bilderZeichnen();
        fehler('fotos', '');
      });
      li.appendChild(weg);

      bilderListe.appendChild(li);
    });
  }

  function dateienNehmen(liste) {
    fehler('fotos', '');
    var meldungen = [];
    Array.prototype.slice.call(liste).forEach(function (datei) {
      if (stand.fotos.length >= MAX_FOTOS) {
        meldungen.push('Mehr als ' + MAX_FOTOS + T('ns.js.rt.zu_viele_bilder', ' Bilder gehen nicht.'));
        return;
      }
      if (ERLAUBTE_TYPEN.indexOf(datei.type) === -1) {
        meldungen.push('„' + datei.name + '“ ist kein PNG oder JPG.');
        return;
      }
      // Vor dem Verkleinern grosszuegig deckeln: ein Rohbild darf das
      // Vierfache des Zielwerts haben, das Verkleinern drueckt es darunter.
      if (datei.size > MAX_MB * 4 * 1048576) {
        meldungen.push('„' + datei.name + '“ ist mit ' + mb(datei.size) + ' zu groß.');
        return;
      }
      var eintrag = {
        datei: datei,
        name: datei.name,
        groesse: datei.size,
        vorschau: URL.createObjectURL(datei),
        zustand: 'laedt',
        meldung: ''
      };
      stand.fotos.push(eintrag);
      bilderZeichnen();
      verkleinern(datei, function (klein) {
        eintrag.datei = klein;
        eintrag.name = klein.name;
        eintrag.groesse = klein.size;
        if (eintrag.groesse > MAX_MB * 1048576) {
          eintrag.zustand = 'fehler';
          eintrag.meldung = T('ns.js.rt.zu_gross_vor', 'zu groß (') + mb(eintrag.groesse) + T('ns.js.rt.zu_gross_nach', '), bitte ein kleineres Bild');
        } else {
          eintrag.zustand = 'gut';
        }
        bilderZeichnen();
      });
    });
    if (meldungen.length) fehler('fotos', meldungen.join(' '));
    bilderZeichnen();
  }

  if (dateiFeld) {
    dateiFeld.addEventListener('change', function () {
      dateienNehmen(dateiFeld.files);
      dateiFeld.value = '';
    });
  }

  if (ablage) {
    ['dragenter', 'dragover'].forEach(function (name) {
      ablage.addEventListener(name, function (ev) {
        ev.preventDefault();
        ablage.classList.add('is-drueber');
      });
    });
    ['dragleave', 'drop'].forEach(function (name) {
      ablage.addEventListener(name, function (ev) {
        ev.preventDefault();
        ablage.classList.remove('is-drueber');
      });
    });
    ablage.addEventListener('drop', function (ev) {
      if (ev.dataTransfer && ev.dataTransfer.files) dateienNehmen(ev.dataTransfer.files);
    });
  }

  function fertigeBilder() {
    return stand.fotos.filter(function (e) {
      return e.zustand === 'gut';
    });
  }

  /* ============================================================
     G. Schritt 4: Absender
     ============================================================ */

  var feldName = q('[data-rt-name]');
  var feldTelefon = q('[data-rt-telefon]');
  var feldStrasse = q('[data-rt-strasse]');
  var feldPlz = q('[data-rt-plz]');
  var feldOrt = q('[data-rt-ort]');
  var feldLand = q('[data-rt-land]');
  var feldNachricht = q('[data-rt-nachricht]');
  var boxDatenschutz = q('[data-rt-datenschutz]');
  var raumZusammen = q('[data-rt-zusammen]');
  var knopfSenden = q('[data-rt-senden]');

  function anschrift() {
    var zeilen = [
      txt(feldStrasse && feldStrasse.value),
      (txt(feldPlz && feldPlz.value) + ' ' + txt(feldOrt && feldOrt.value)).trim(),
      txt(feldLand && feldLand.value)
    ];
    return zeilen
      .filter(function (z) {
        return z;
      })
      .join('\n');
  }

  function zusammenfassen() {
    if (!raumZusammen) return;
    var artikel = zeilenLesen();
    var punkte = [
      [T('ns.js.rt.z_bestellung', 'Bestellung'), stand.geprueft ? stand.bestellung.nummer + ', ' + stand.bestellung.datum_de : T('ns.js.rt.ohne_nummer', 'ohne Nummer')],
      [T('ns.js.rt.z_anliegen', 'Anliegen'), anliegenWert() || T('ns.js.rt.noch_offen', 'noch offen')],
      [T('ns.js.rt.z_wunschfarbe', 'Wunschfarbe'), willUmtausch() ? txt(feldWunsch && feldWunsch.value) || T('ns.js.rt.noch_offen', 'noch offen') : ''],
      [
        T('ns.js.rt.z_artikel', 'Artikel'),
        artikel.length
          ? artikel
              .map(function (a) {
                return a.menge + '× ' + a.titel + (a.variante ? ', ' + a.variante : '') + (a.grund ? ' (' + a.grund + ')' : '');
              })
              .join('<br>')
          : T('ns.js.rt.noch_keine', 'noch keine')
      ],
      [T('ns.js.rt.z_fotos', 'Fotos'), fertigeBilder().length ? fertigeBilder().length + T('ns.js.rt.bilder_anzahl', ' Bild(er)') : T('ns.js.rt.keine', 'keine')],
      [T('ns.js.rt.z_antwort_an', 'Antwort an'), stand.mail || txt(feldMail && feldMail.value) || T('ns.js.rt.noch_offen', 'noch offen')]
    ];
    var html = '<dl>';
    punkte.forEach(function (p) {
      if (!p[1]) return; // leere Zeilen sagen nichts und kosten Platz
      html += '<dt>' + p[0] + '</dt><dd>' + p[1] + '</dd>';
    });
    html += '</dl>';
    raumZusammen.innerHTML = html;
  }

  /* ============================================================
     H. Pruefung je Schritt
     ============================================================ */

  function markiere(feld, an) {
    if (feld) feld.classList.toggle('is-falsch', !!an);
  }

  function schrittGeprueft(index) {
    fehlerWeg(SCHRITTE[index]);

    if (index === 0) {
      var mail = txt(feldMail && feldMail.value).toLowerCase();
      if (!mailGueltig(mail)) {
        markiere(feldMail, true);
        fehler('suche', T('ns.js.rt.ohne_mail', 'Ohne E-Mail-Adresse können wir dir nicht antworten.'));
        return false;
      }
      stand.mail = mail;
      if (!stand.geprueft) stand.nr = txt(feldNr && feldNr.value).replace(/\s+/g, '');
      if (!qa('[data-rt-zeile]', artikelRaum).length) gastZeileAnlegen();
      return true;
    }

    if (index === 1) {
      var zeilen = zeilenLesen();
      if (!zeilen.length) {
        fehler('artikel', T('ns.js.rt.artikel_anhaken', 'Bitte hak den Artikel an, den du zurückschicken möchtest.'));
        return false;
      }
      var ohneGrund = false;
      var ohneFarbe = false;
      qa('[data-rt-zeile]', artikelRaum).forEach(function (zeile) {
        var kasten = q('[data-rt-zeile-an]', zeile);
        if (!kasten || !kasten.checked) return;
        var grund = q('[data-rt-zeile-grund]', zeile);
        var farbe = q('[data-rt-zeile-farbe]', zeile);
        if (grund && !txt(grund.value)) {
          markiere(grund, true);
          ohneGrund = true;
        }
        if (farbe && !txt(farbe.value)) {
          markiere(farbe, true);
          ohneFarbe = true;
        }
      });
      if (ohneFarbe) {
        fehler('artikel', T('ns.js.rt.farbe_waehlen', 'Bitte wähle die Farbe des Artikels.'));
        return false;
      }
      if (ohneGrund) {
        fehler('artikel', T('ns.js.rt.grund_je_artikel', 'Bitte sag uns je Artikel kurz, woran es liegt.'));
        return false;
      }
      return true;
    }

    if (index === 2) {
      if (!anliegenWert()) {
        fehler('anliegen', T('ns.js.rt.anliegen_waehlen', 'Bitte wähle aus, worum es geht.'));
        return false;
      }
      if (willUmtausch() && feldWunsch && !txt(feldWunsch.value)) {
        markiere(feldWunsch, true);
        fehler('wunsch', T('ns.js.rt.wunsch_waehlen', 'Bitte sag uns, welche Farbe du stattdessen möchtest.'));
        return false;
      }
      // Der Zustand entscheidet mit über Erstattung, Ersatz oder
      // Reparatur. Ein Klick, und er erspart eine Rückfrage.
      if (feldZustand && !txt(feldZustand.value)) {
        markiere(feldZustand, true);
        fehler('zustand', T('ns.js.rt.zustand_waehlen', 'Bitte wähle den Zustand des Artikels.'));
        return false;
      }
      var beschreibung = txt(feldBeschreibung && feldBeschreibung.value);
      if (beschreibung.length < zahl(feldBeschreibung && feldBeschreibung.getAttribute('data-rt-min'), 10)) {
        markiere(feldBeschreibung, true);
        fehler('beschreibung', T('ns.js.rt.beschreiben', 'Beschreib bitte kurz, was los ist. Ein Satz genügt.'));
        return false;
      }
      return true;
    }

    if (index === 3) {
      if (txt(feldName && feldName.value).length < 2) {
        markiere(feldName, true);
        fehler('name', T('ns.js.rt.name_eintragen', 'Bitte trag deinen Namen ein.'));
        return false;
      }
      if (!txt(feldStrasse && feldStrasse.value) || !txt(feldPlz && feldPlz.value) || !txt(feldOrt && feldOrt.value)) {
        markiere(feldStrasse, !txt(feldStrasse && feldStrasse.value));
        markiere(feldPlz, !txt(feldPlz && feldPlz.value));
        markiere(feldOrt, !txt(feldOrt && feldOrt.value));
        fehler('anschrift', T('ns.js.rt.anschrift_eintragen', 'Bitte trag Straße, Postleitzahl und Ort ein.'));
        return false;
      }
      if (!boxDatenschutz || !boxDatenschutz.checked) {
        if (boxDatenschutz && boxDatenschutz.closest('.ns-rt__haken')) {
          boxDatenschutz.closest('.ns-rt__haken').classList.add('is-falsch');
        }
        fehler('datenschutz', T('ns.js.rt.einverstaendnis', 'Ohne dein Einverständnis dürfen wir den Fall nicht bearbeiten.'));
        return false;
      }
      return true;
    }

    return true;
  }

  /* ============================================================
     I. Absenden
     ============================================================ */

  function knopfText(text) {
    if (!knopfSenden) return;
    var innen = q('.ns-rt__btn-text', knopfSenden);
    if (innen) innen.textContent = text;
  }

  FORM.addEventListener('submit', function (ev) {
    ev.preventDefault();
    if (stand.laeuft || stand.gesendet) return;
    // Abgeschickt wird nur aus dem letzten Schritt. Sonst koennte die
    // Eingabetaste in Schritt 1 das Formular absenden, und der Kunde
    // bekaeme Fehlermeldungen zu Feldern, die er noch gar nicht gesehen
    // hat.
    if (stand.schritt !== SCHRITTE.length - 1) return;
    if (!schrittGeprueft(3)) return;
    if (!ENDPUNKT) {
      fehler('senden', mitAusweg(T('ns.js.rt.nicht_verbunden', 'Das Formular ist gerade nicht verbunden.')));
      return;
    }
    absenden();
  });

  function absenden() {
    var urtext = knopfSenden ? txt(q('.ns-rt__btn-text', knopfSenden).textContent) : '';
    stand.laeuft = true;
    if (knopfSenden) knopfSenden.disabled = true;
    knopfText(T('ns.js.rt.wird_gesendet_knopf', 'Wird gesendet …'));
    fehler('senden', '');
    melde(T('ns.js.rt.wird_gesendet', 'Die Anmeldung wird gesendet'));

    var daten = new FormData();
    daten.append('mail', stand.mail);
    // Auch eine Nummer, zu der nichts gefunden wurde, geht mit. Ein
    // Zahlendreher ist fuer das Team ein Anhaltspunkt, und der Worker
    // schreibt ohne gueltigen Nachweis ohnehin "nicht bestaetigt"
    // daneben, ohne Datum und ohne Frist.
    daten.append('nr', stand.nr);
    daten.append('nachweis', stand.nachweis);
    daten.append('anliegen', anliegenWert());
    daten.append('wunsch', willUmtausch() ? txt(feldWunsch && feldWunsch.value) : '');
    daten.append('zustand', txt(feldZustand && feldZustand.value));
    daten.append('beschreibung', txt(feldBeschreibung && feldBeschreibung.value));
    daten.append('nachricht', txt(feldNachricht && feldNachricht.value));
    daten.append('name', txt(feldName && feldName.value));
    daten.append('telefon', txt(feldTelefon && feldTelefon.value));
    daten.append('anschrift', anschrift());
    daten.append('artikel', JSON.stringify(zeilenLesen()));
    var widerrufAn = !!(widerrufBox && widerrufBox.checked && widerrufWrap && !widerrufWrap.hidden);
    daten.append('widerruf', widerrufAn ? '1' : '');
    daten.append('datenschutz', boxDatenschutz && boxDatenschutz.checked ? '1' : '');
    daten.append('dauer', String(new Date().getTime() - START));
    var falle = q('[name="hp"]');
    daten.append('hp', falle ? falle.value : '');
    fertigeBilder().forEach(function (e) {
      daten.append('fotos', e.datei, e.name);
    });

    fetch(ENDPUNKT, { method: 'POST', body: daten, credentials: 'omit' })
      .then(lesen)
      .catch(function () {
        return { http: 0, daten: null };
      })
      .then(function (a) {
        stand.laeuft = false;
        if (a.daten && a.daten.ok === true) {
          stand.gesendet = true;
          zeigeFertig(a.daten);
          return;
        }
        if (knopfSenden) knopfSenden.disabled = false;
        knopfText(urtext);
        fehler('senden', mitAusweg(antworttext(a.daten, a.http)));
      });
  }

  function zeigeFertig(antwort) {
    var kopf = q('[data-rt-kopf]');
    var ablauf = q('[data-rt-ablauf]');
    FORM.hidden = true;
    if (kopf) kopf.hidden = true;
    if (ablauf) ablauf.hidden = true;
    if (!FERTIG) return;
    var nummer = q('[data-rt-vorgang]');
    if (nummer) nummer.textContent = txt(antwort.vorgang);
    var mailZeile = q('[data-rt-fertig-mail]');
    if (mailZeile) {
      mailZeile.textContent = antwort.bestaetigung
        ? T('ns.js.rt.bestaetigung_an', 'Eine Bestätigung ist an ') + stand.mail + T('ns.js.rt.unterwegs', ' unterwegs.')
        : T('ns.js.rt.alles_bekommen', 'Wir haben alles bekommen. Die Bestätigungsmail an ') + stand.mail + T('ns.js.rt.mail_nicht_geklappt', ' hat gerade nicht geklappt, an deinem Vorgang ändert das nichts.');
      mailZeile.hidden = false;
    }
    FERTIG.hidden = false;
    FERTIG.focus();
    rollenZu(FERTIG);
    melde(T('ns.js.rt.angemeldet', 'Deine Rücksendung ist angemeldet. Vorgangsnummer ') + txt(antwort.vorgang));
  }

  /* ============================================================
     J. Schutz vor dem versehentlichen Verlassen
     ============================================================ */

  FORM.addEventListener('input', function () {
    stand.beruehrt = true;
  });

  window.addEventListener('beforeunload', function (ev) {
    if (!stand.beruehrt || stand.gesendet) return;
    ev.preventDefault();
    // Der Text ist ohne Wirkung, alle Browser zeigen ihren eigenen.
    // Nur ein gesetzter Rueckgabewert loest die Nachfrage aus.
    ev.returnValue = '';
    return '';
  });

  /* ============================================================
     K. Start
     ============================================================ */

  zeigeSchritt(0, false);

  // Kommt jemand aus der Sendungsverfolgung, steht die Nummer schon in
  // der Adresszeile. Das Feld fuellen, aber nichts von selbst abschicken.
  var ausAdresse = /[?&]nr=([^&]+)/.exec(window.location.search);
  if (ausAdresse && feldNr) {
    feldNr.value = decodeURIComponent(ausAdresse[1]).replace(/[^\d#]/g, '');
  }

  // Kleiner Ringpuffer fuer die Pruefskripte. Kein Personenbezug.
  window.__nsRetoure = {
    schritt: function () {
      return stand.schritt;
    },
    zustand: function () {
      return {
        schritt: stand.schritt,
        geprueft: stand.geprueft,
        gast: stand.gast,
        zeilen: qa('[data-rt-zeile]', artikelRaum).length,
        gewaehlt: zeilenLesen().length,
        fotos: stand.fotos.length,
        gesendet: stand.gesendet
      };
    }
  };
})();
